export default "__VITE_ASSET__DhdBCyV8__"